package com.fantasytenis.shared.data.auth.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * Request DTOs
 */
@Serializable
data class LoginRequest(
    val email: String,
    val password: String
)

@Serializable
data class RegisterRequest(
    val email: String,
    val password: String,
    @SerialName("firstName")
    val firstName: String,
    @SerialName("lastName")
    val lastName: String,
    val username: String
)

@Serializable
data class RefreshTokenRequest(
    @SerialName("refreshToken")
    val refreshToken: String
)

@Serializable
data class ChangePasswordRequest(
    @SerialName("currentPassword")
    val currentPassword: String,
    @SerialName("newPassword")
    val newPassword: String
)

@Serializable
data class UpdateUserRequest(
    @SerialName("firstName")
    val firstName: String? = null,
    @SerialName("lastName")
    val lastName: String? = null,
    @SerialName("phoneNumber")
    val phoneNumber: String? = null,
    @SerialName("avatarUrl")
    val avatarUrl: String? = null,
    val username: String? = null,
    @SerialName("avatarType")
    val avatarType: String? = null,
    @SerialName("avatarPresetId")
    val avatarPresetId: String? = null
)

/**
 * Response DTOs
 */
@Serializable
data class AuthResponse(
    @SerialName("accessToken")
    val accessToken: String,
    @SerialName("refreshToken")
    val refreshToken: String,
    val user: UserDto
)

@Serializable
data class UserDto(
    val id: String,
    val email: String,
    @SerialName("firstName")
    val firstName: String,
    @SerialName("lastName")
    val lastName: String,
    @SerialName("phoneNumber")
    val phoneNumber: String? = null,
    @SerialName("avatarUrl")
    val avatarUrl: String? = null,
    @SerialName("kycStatus")
    val kycStatus: String = "pending",
    val role: String = "user",
    @SerialName("createdAt")
    val createdAt: String? = null,
    val username: String? = null,
    @SerialName("avatarType")
    val avatarType: String = "none",
    @SerialName("avatarPresetId")
    val avatarPresetId: String? = null
)

@Serializable
data class TokenResponse(
    @SerialName("accessToken")
    val accessToken: String,
    @SerialName("refreshToken")
    val refreshToken: String
)

/**
 * Username availability check
 */
@Serializable
data class CheckUsernameData(
    val available: Boolean,
    val suggestion: String = ""
)

/**
 * Avatar upload URL data
 */
@Serializable
data class AvatarUploadData(
    @SerialName("uploadUrl")
    val uploadUrl: String,
    @SerialName("publicUrl")
    val publicUrl: String,
    @SerialName("expiresAt")
    val expiresAt: String
)

/**
 * Avatar upload request
 */
@Serializable
data class GetAvatarUploadUrlRequest(
    @SerialName("contentType")
    val contentType: String
)

/**
 * Preset avatar
 */
@Serializable
data class PresetAvatarDto(
    val id: String,
    val url: String,
    val category: String
)

/**
 * Preset avatars data
 */
@Serializable
data class PresetAvatarsData(
    val avatars: List<PresetAvatarDto>
)
